import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { message } from 'antd';

const CopyString = ({ text, abbreviationLength = 0 }) => {

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text).then(() => {
      message.success('Copied to clipboard!');
    }).catch((error) => {
      console.error('Error copying text: ', error);
    });
  };

  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center'}}>
      { abbreviationLength > 0
        ? <p style={{ margin: 0 }}>{text.substring(text.length, text.length - abbreviationLength)}</p> 
        : <p style={{ margin: 0 }}>{text}</p>
      }
      <button style={{ border: 'none', padding: '0', background: 'none', color: 'grey'}}onClick={copyToClipboard}><CopyOutlined /></button>
    </div>
  );
};

export default CopyString;